import script from "./tenant-details-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./tenant-details-page.vue?vue&type=script&setup=true&lang=ts"

import "./tenant-details-page.vue?vue&type=style&index=0&id=5423af3c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5423af3c"]])

export default __exports__